
import React from 'react';
import { withStyles, Grid, withRouter } from '../../material-ui';
import MatchHeader from './MatchHeader';
import Apis from '../../network/Apis';
import DateUtils from '../../control/dateutils';
import NoMatch from '../home/NoMatch';
import { MatchItem } from './view';
import AppData from '../../model/AppData';
import AppUtils from '../../control/apputlis';
import MStatusBar from '../view/MStatusBar';
import ReactPullLoad, { STATS } from "react-pullload";

class MatchPage extends React.Component {

    constructor(props) {
        super(props);
        let tabIndex = AppUtils.getStorageInt(AppUtils.MATCH_SELECTED_TAB_INDEX);
        let typeIndex = AppUtils.getStorageInt(AppUtils.MATCH_SELECTED_TYPE_INDEX);


        this.state = {
            tabIndex: tabIndex,
            typeIndex: typeIndex,
            oneTypeData: [],
            data: [],
            matchsData: [],
            allData: [],
            isRefreshing: false,
            isOpen: true,
            isLoading: true,
            upPage: 0,//今日往上的page
            downPage: 1,//今日往下的page
            dayType: 1,//1今日往下2今日往上
            isShowToday: false,
            isFromRestDetail: false,
            hasMore: true,
            action: STATS.init,
            index: 1
        };
        this.dateTime = DateUtils.getCurTime() / 1000;
    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'MatchPage');
        AppData.checkUpdate();
        let oneTypeData = AppData.getSchedusTypeData();
        if (oneTypeData.length == 0) {
            this.getShowOneType();
        } else {
            this.setState({ oneTypeData: oneTypeData }, () => {
                let index = this.state.typeIndex < oneTypeData.length ? this.state.typeIndex : 0;
                this.getMatchs(oneTypeData[index]);
            });
        }

        let { os, token, uid, fastkey, roomIp, roomPort, customerId, fid } = this.props.match.params;
        if (fid && fid != 0) {
            AppData.me.free_id = fid
        }

        if (os && os != null && AppData.os == '') {
            AppData.os = os;
            AppUtils.setStorageItem('uid', uid)
            AppUtils.setStorageItem('fastkey', fastkey)
            AppUtils.setStorageItem('roomIp', roomIp)
            AppUtils.setStorageItem('roomPort', roomPort)
        }

        if (token && token.length > 6) {
            AppData.me.token = token
        }
        if (customerId && customerId != 0) {
            AppData.me.customer_id = customerId
        }

        // let { channel, token, uid, nav, os, isMatch } = this.props.match.params;
        // if (AppData.os != 'ios') {
        //     AppData.os = os;
        //     AppData.isMatch = isMatch;
        // }
    }

    componentWillUnmount() {
        AppUtils.setStorageItem(AppUtils.MATCH_SELECT_TIMER, 0);
        this.setState = () => false;
    }

    getShowOneType = async () => {
        //找到足球篮球的标题数据
        let result = await Apis.encryptionShowOneType();
        if (result.code == 200) {
            AppData.setSchedusTypeData(result.data);
            this.setState({ oneTypeData: result.data });
            if (result.data.length != 0) {
                let index = this.state.typeIndex < result.data.length ? this.state.typeIndex : 0;
                this.getMatchs(result.data[index]);
            }
        }
    }

    getMatchs = async (val, limit = 20) => {
        // type,day_type, page
        //获取数据
        let page;
        if (this.state.dayType == 1) {
            page = this.state.downPage;
        } else {
            page = this.state.upPage;
        }
        // console.log(this.state.dayType);
        // console.log(page);

        //时间，往前三个小时
        let time = Date.now();
        time = time - 1000 * 60 * 60 * 3
        time = time.toString()
        time = time.substring(0, time.length - 3)
        let result = await Apis.encryptionMatch(val.type_id, this.state.dayType, page, time, limit);
        if (result.code == 200) {
            if (result.data.length == 0) {
                return;
            }
            let tempData = this.state.matchsData;
            tempData = tempData.concat(result.data);
            this.state.matchsData = tempData;
            //时间升序
            if (tempData.length > 0) {
                tempData.sort((x, y) => {
                    return x.match_time - y.match_time;
                })
            }
            //弄好的数据
            //let valList = [];
            //同一天的，放到一个数组里
            // var json = {};
            // for (let i = 0; i < tempData.length; i++) {
            //     let timestamp = tempData[i].match_time;
            //     let day = DateUtils.getDate(timestamp);
            //     //如果不存在
            //     if (!json[day]) {
            //         let list = [];
            //         list.push(tempData[i]);
            //         valList.push(list);
            //         json[day] = 1;
            //     } else {
            //         for (let j = 0; j < valList.length; j++) {
            //             let item = valList[j][0];
            //             let itemTimestamp = item.match_time;
            //             let itemDay = DateUtils.getDate(itemTimestamp);
            //             if (itemDay == day) {
            //                 valList[j].push(tempData[i])
            //             }

            //         }
            //     }
            // }  
            this.setState({ data: tempData }, () => {

            })
            // AppData.setSchedusMatchData(val.type_id, result.data);
            // this.filerMatchs(this.state.matchsData, this.state.tabIndex);
        }

    }

    _handleChange = (val) => {
        const { oneTypeData } = this.state;
        let i = 0;
        for (; i < oneTypeData.length; i++) {
            if (oneTypeData[i].type_id == val.type_id) {
                break;
            }
        }
        this.state.typeIndex = i;
        AppUtils.setStorageItem(AppUtils.MATCH_SELECTED_TYPE_INDEX, this.state.typeIndex);
        this.state.matchsData = [];
        //返回顶部
        if (this.listView) {
            this.listView.scrollTo(0, 0);
        }
        this.state.dayType = 1;
        this.state.upPage = 0;
        this.state.downPage = 1;
        this.getMatchs(val);
    }



    _onRefreshUpHistliy = () => {
        //下拉获取历史记录
        this.state.dayType = 2;
        this.state.upPage++;
        const { oneTypeData } = this.state;
        let index = this.state.typeIndex < oneTypeData.length ? this.state.typeIndex : 0;
        this.getMatchs(oneTypeData[index], 5);
    }

    _onRefresh = () => {
        //这个才是刷新
        const { oneTypeData } = this.state;
        this.state.dayType = 1;
        this.state.upPage = 0;
        this.state.downPage = 1;
        this.state.matchsData = [];
        let index = this.state.typeIndex < oneTypeData.length ? this.state.typeIndex : 0;
        //返回顶部
        if (this.listView) {
            this.listView.scrollTo(0, 0);
        }
        this.getMatchs(oneTypeData[index]);
    }

    // _handleTimer = () => {
    //     //跳转到日期组件
    //     const { oneTypeData } = this.state;
    //     let type_id = oneTypeData[this.state.typeIndex].type_id;
    //     this.props.history.push({ pathname: '/matchcalendar/' + type_id });
    // }

    _onEndReached = () => {

        this.state.downPage++;
        this.state.dayType = 1;
        const { oneTypeData } = this.state;
        let index = this.state.typeIndex < oneTypeData.length ? this.state.typeIndex : 0;
        this.state.isShowToday = true
        this.getMatchs(oneTypeData[index]);
    }

    _renderFooter = () => {
        return (<Grid style={{ height: 100 }}></Grid>);
    }

    _renderHeader = () => {
        return (
            <Grid container direction='column' alignItems='center'>
                <MStatusBar />
            </Grid>
        );
    }



    _renderItem = (item, rowID) => {
        const { data } = this.state;
        let num = Number(rowID);
        let showDate = true;
        if (num != 0) {
            showDate = !DateUtils.sameDate(item.match_time, data[num - 1].match_time)
        }

        //赛程列表 
        return (
            <Grid container key={rowID} id={'item-' + rowID} >
                <MatchItem line={true} data={item} showDate={showDate} />
            </Grid>
        )

    }
    scrollToAnchor = () => {
        const { oneTypeData, tabIndex } = this.state;
        this.setState({ data: [], downPage: 1, upPage: 0 }, () => {
            this.getMatchs(oneTypeData[tabIndex])
        })
    }

    handleAction = action => { 
        if (action === STATS.loading) {
            this._onEndReached()
        } else if (action === STATS.refreshing) {
            this._onRefreshUpHistliy()
        }
    }

    render() {
        const { classes } = this.props;
        const { data, oneTypeData, hasMore, typeIndex, tabIndex, isLoading } = this.state;
        console.log("isShowToday====>", this.state.isShowToday)
        let marginTop = 48;
        return (
            <Grid container direction='column' alignItems='center' className={classes.list}>
                <Grid container direction='column' alignItems='center' style={{ position: 'fixed', zIndex: 100, backgroundColor: '#FFF' }} >
                    <MStatusBar />
                    <MatchHeader value={typeIndex} data={oneTypeData} num={data.length} onChange={(val) => this._handleChange(val)} />
                    {/* <MatchTitle value={tabIndex} onChange={(val) => this._handleStatus(val)} onTimer={() => this._handleTimer(tabIndex)} /> */}
                </Grid>
                <Grid container direction='column' alignItems='center' style={{ width: '100vw', marginTop: marginTop }}>
                    {
                        data.length > 0 && <ReactPullLoad
                            downEnough={150}
                            action={this.state.action}
                            handleAction={this.handleAction}
                            hasMore={hasMore}
                            style={{ width: '100%' }}
                            distanceBottom={1000}>
                            {this._renderHeader()}
                            {data.map((item, i) => this._renderItem(item, i))}
                            {this._renderFooter()}

                        </ReactPullLoad>
                    }
                    {
                        data.length == 0 && <Grid container justifyContent='center' alignItems='center' style={{ width: '100vw', minHeight: '90vh', marginTop: marginTop }}  >
                            <NoMatch isLoading={isLoading} />
                        </Grid>
                    }
                </Grid>
                {this.state.isShowToday &&
                    <Grid className={classes.backNowDay} style={{ bottom: 100 }} onClick={() => this.scrollToAnchor()} container justifyContent='center' alignItems='center'>返回今天</Grid>
                }
            </Grid>
        );


    }
}

export default withRouter(withStyles((theme) => ({
    list: {
        width: '100vw',
        margin: theme.spacing(0),
        padding: theme.spacing(0),
        // backgroundColor:'#F3F3F3' 
        backgroundColor: '#EFEFF4',
        position: 'relative'
    },
    onRefreshIcon: {
        position: 'absolute',
        bottom: 70,
        right: 0,
        width: 70,
        height: 70,
    },
    onRefreshIconImg: {
        width: 70,
        height: 70,
    },
    backNowDay: {
        position: 'fixed',
        width: 100,
        height: 30,
        borderRadius: 30,
        color: '#fff',
        fontSize: 12,
        backgroundColor: '#235DF1',
        zIndex: 10000,
    }

}))(MatchPage));